/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeaderboardMyRankEntry
 */
export interface LeaderboardMyRankEntry {
    /**
     * Echo of the requested idOrSlug. Use this to map results back to the input.
     * @type {string}
     * @memberof LeaderboardMyRankEntry
     */
    idOrSlug: string;
    /**
     * 
     * @type {boolean}
     * @memberof LeaderboardMyRankEntry
     */
    isParticipating: boolean;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardMyRankEntry
     */
    rank?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardMyRankEntry
     */
    previousRank?: number;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardMyRankEntry
     */
    rankChange?: number;
    /**
     * 0-100, share of the field at or below this rank. Emitted since the route shipped; schema omission fixed 2026-09-08.
     * @type {number}
     * @memberof LeaderboardMyRankEntry
     */
    percentile?: number;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardMyRankEntry
     */
    value: number;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardMyRankEntry
     */
    eventCount: number;
}

/**
 * Check if a given object implements the LeaderboardMyRankEntry interface.
 */
export function instanceOfLeaderboardMyRankEntry(value: object): value is LeaderboardMyRankEntry {
    if (!('idOrSlug' in value) || value['idOrSlug'] === undefined) return false;
    if (!('isParticipating' in value) || value['isParticipating'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('eventCount' in value) || value['eventCount'] === undefined) return false;
    return true;
}

export function LeaderboardMyRankEntryFromJSON(json: any): LeaderboardMyRankEntry {
    return LeaderboardMyRankEntryFromJSONTyped(json, false);
}

export function LeaderboardMyRankEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaderboardMyRankEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'idOrSlug': json['idOrSlug'],
        'isParticipating': json['isParticipating'],
        'rank': json['rank'] == null ? undefined : json['rank'],
        'previousRank': json['previousRank'] == null ? undefined : json['previousRank'],
        'rankChange': json['rankChange'] == null ? undefined : json['rankChange'],
        'percentile': json['percentile'] == null ? undefined : json['percentile'],
        'value': json['value'],
        'eventCount': json['eventCount'],
    };
}

export function LeaderboardMyRankEntryToJSON(json: any): LeaderboardMyRankEntry {
    return LeaderboardMyRankEntryToJSONTyped(json, false);
}

export function LeaderboardMyRankEntryToJSONTyped(value?: LeaderboardMyRankEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idOrSlug': value['idOrSlug'],
        'isParticipating': value['isParticipating'],
        'rank': value['rank'],
        'previousRank': value['previousRank'],
        'rankChange': value['rankChange'],
        'percentile': value['percentile'],
        'value': value['value'],
        'eventCount': value['eventCount'],
    };
}

